import { Transition } from '@headlessui/react'
import classnames from 'classnames'

export interface ModalProps {
    show: boolean
    onClose: () => void
    children: React.ReactNode
    bgColor?: string
}
export function Modal({
    show = false,
    onClose,
    children,
    bgColor = 'rgba(0, 0, 0, 0.6)',
}: ModalProps): JSX.Element {
    const modalContainerStyles = classnames(
        'absolute left-0 top-0 w-screen h-screen flex flex-row justify-center items-center',
    )

    const modalStyles = classnames(' absolute w-max h-max bg-white rounded-sm')

    return (
        <Transition
            show={show}
            as='div'
            className={modalContainerStyles}
            style={{ backgroundColor: bgColor }}
            onClick={onClose}
            enter='transition-opacity duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='transition-opacity duration-300 delay-300'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'>
            <Transition.Child
                as='div'
                className={modalStyles}
                enter='transition ease-in-out duration-300 delay-300  opacity-0'
                enterFrom='opacity-0'
                enterTo='opacity-100'
                leave='transition ease-in-out duration-300  opacity-100'
                leaveFrom='opacity-100'
                leaveTo='opacity-0'>
                {children}
            </Transition.Child>
        </Transition>
    )
}
